
import { useState, useEffect } from 'react';
import { usePostHog } from 'posthog-js/react';
import { getFeatureFlags, type FeatureFlags } from '@/config/features';

export const useFeatureFlags = () => {
  const posthog = usePostHog();
  const [flags, setFlags] = useState<FeatureFlags>(() => getFeatureFlags());

  useEffect(() => {
    const updateFlags = () => {
      // Get PostHog feature flags
      const posthogFlags: Record<string, boolean | string> = {};
      if (posthog) {
        // Check specific flags we care about
        posthogFlags['live-guidance'] = posthog.isFeatureEnabled('live-guidance') || false;
      }
      const newFlags = getFeatureFlags(posthogFlags);
      setFlags(newFlags);
    };

    // Update flags when PostHog loads
    if (posthog) {
      updateFlags();
      
      // Listen for PostHog feature flag changes
      posthog.onFeatureFlags(updateFlags);
    }

    // Also listen for manual flag changes (development only)
    const handleFlagsChange = (event: CustomEvent<FeatureFlags>) => {
      setFlags(event.detail);
    };

    window.addEventListener('featureFlagsChanged', handleFlagsChange as EventListener);
    
    return () => {
      window.removeEventListener('featureFlagsChanged', handleFlagsChange as EventListener);
    };
  }, [posthog]);

  return flags;
};

export const useFeatureFlag = (flag: keyof FeatureFlags): boolean => {
  const flags = useFeatureFlags();
  return flags[flag];
};
